<template>
  <div>
    <div class="back" @click="back">
      <i></i>
      <span>返回</span>
    </div>
    <div class="nav_title flex1">
      <h3>学习情况</h3>
      <h2>{{ $parent.title }}</h2>
    </div>
    <div class="nav_scend">
      <div class="nav_left">
        <div id="pieEchars" class="pieEchars"></div>
      </div>
      <!-- <div class="jiange"></div> -->
      <div class="nav_right">
        <div id="pieEcharstwo" class="pieEcharstwo"></div>
      </div>
    </div>
    <div class="nav_content">
      <h2 style="margin-bottom: 16px;">科室进度对比</h2>
      <div id="lineEchars" class="lineEchars"></div>
    </div>
    <div class="nav_title">
      <h3>考生统计详情</h3>
    </div>
    <div class="nav_threed">
      <div class="waitingcom_title">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="考生姓名：">
            <el-input
              v-model="formInline.user"
              placeholder="请输入考生姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="科室：">
            <el-input
              v-model="formInline.region"
              placeholder="请输入科室"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否学完：">
            <el-select
              v-model="formInline.isComplete"
              placeholder="请选择"
              @change="onChange"
            >
              <el-option
                v-for="item in isCompleteArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="query_btn">
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button
            icon="el-icon-refresh"
            class="searchbtn sonbtn"
            @click="resetForm('formLabelAlign')"
            >重置</el-button
          >
          <el-button
            type="primary"
            class="el-icon-download"
            @click="exportExcel"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 表格部分 -->
      <div v-loading="loading">
        <el-table
          ref="tabledata"
          :data="getData"
          style="width: 100%"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
          }"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage3 - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
            :show-overflow-tooltip="true"
          >
            <!-- <template slot-scope="scope">
              <p v-if="index == 0">
                {{ scope.row.RealName }}
              </p>
              <p v-if="index == 1">
                {{ scope.row.UserName }}
              </p>
              <p v-if="index == 2">
                {{ scope.row.Telephone }}
              </p>
              <p v-if="index == 3">
                {{ scope.row.DepartmentName }}
              </p>
              <p v-if="index == 4">
                {{ scope.row.PTitle }}
              </p>
              <p v-if="index == 5">
                {{ scope.row.isComplete }}
              </p>
              <p v-if="index == 6">
                {{ scope.row.videoTime }}
              </p>
              <p v-if="index == 7">
                {{ scope.row.watchTime }}
              </p>
              <p v-if="index == 8">
                {{ scope.row.progress1 }}
              </p>
              <p
                v-if="index == 9 && $parent.courseware !== 'courseware'"
                class="openDatil"
                @click="openDatil(scope.row)"
              >
                {{ scope.row.userCount }}
              </p>
            </template> -->
          </el-table-column>
          <!-- 点击次数 -->
          <el-table-column label="点击次数">
            <template slot-scope="scope">
              <p class="openDatil" @click="openDatil(scope.row)">
                {{ scope.row.userCount }}
              </p>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="foot_box">
          <div class="foot_pagetions">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="showpageindex"
              :page-size="pageSize"
              :page-sizes="pagesizesarr"
              layout="prev, pager, next,sizes, jumper"
              :total="total"
              class="pagination"
            >
            </el-pagination>
          </div>
        </div>
      </div>

      <student :diatilobj="diatilobj" ref="studyDialog"></student>
    </div>
  </div>
</template>

<script>
import student from "./studentStudy.vue";
import option from "@/utils/echarsOptions.js";
import * as echarts from "echarts";
import resourcereq from "@/api/resources";
export default {
  data() {
    return {
      showpageindex: 1, //显示的索引盒子
      currentPage3: 1, //  当前页数
      pageSize: 10,
      total: 100,
      loading: true,
      pagesizesarr: [5, 10, 20, 50, 100],
      diatilobj: {
        studentId: "", //选中考生的ID
        videoId: "", //选中视频或者课件的ID
        courseID: "",
      },
      formInline: {
        user: "", //考生姓名
        region: "", //科室
        isComplete: "", // 是否学完
      },
      isCompleteArr: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      getDataCondition: {
        user: "", //考生姓名
        region: "", //科室
      },
      getData: [],
      formColumns: [],
    };
  },
  components: {
    student,
  },
  props: ["cutcoms"],
  methods: {
    back() {
      if (this.$route.query.trainId) {
        // 培训过来的
        this.$router.push({
          path: this.$route.query.toUrl,
          query: {
            trainId: this.$route.query.trainId,
            toUrl: this.$route.query.toUrl,
            state:'xxqk'
          },
        });
      } else if (this.$parent.newState == 1) {
        this.$parent.newState = 0;
        this.cutcoms(3);
      } else {
        this.cutcoms(0);
      }
      this.$destroy();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPageData(); // 重新发起请求
    },
    handleCurrentChange(val) {
      this.currentPage3 = val;
      this.getPageData(); // 重新发起请求
    },
    // 搜索
    handleQuery() {
      this.loading = true;
      this.currentPage3 = 1;
      if (this.formInline.user) {
        this.getDataCondition.user = this.formInline.user;
      } else {
        this.getDataCondition.user = "";
      }
      if (this.formInline.region) {
        this.getDataCondition.region = this.formInline.region;
      } else {
        this.getDataCondition.region = "";
      }
      this.getPageData();
    },
    // 重置按钮
    resetForm() {
      this.loading = true;
      this.getDataCondition.user = "";
      this.getDataCondition.region = "";
      this.formInline = {
        user: "", //考生姓名
        region: "", //科室
        isComplete: "", // 是否学完
      };
      this.currentPage3 = 1;
      this.loading = true;
      this.getPageData();
    },
    // chang事件查询
    onChange() {
      this.loading = true;
      this.getPageData();
    },
    openDatil(studentId) {
      this.diatilobj.studentId = studentId.UserID;
      this.diatilobj.videoId = studentId.VideoID;
      this.diatilobj.courseID = studentId.CoursewareID;
      this.studyDatail = true;
      this.$refs.studyDialog.dialogVisible = true;
    },
    drawLine() {
      let myChart = echarts.init(document.getElementById("lineEchars"));
      option.lineoption && myChart.setOption(option.lineoption);
    },
    async exportExcel() {
      let pamars = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        videoID: this.$parent.videoid,
      };
      let res;
      if (this.$parent.courseware == "courseware") {
        pamars["courseID"] = this.$parent.videoid;
        res = await resourcereq.courseImportExcel(pamars);
      } else {
        res = await resourcereq.videoImportExcel(pamars);
      }
      const blob = new Blob([res.data]);
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "导出学习进度.xlsx");
      link.click();
      link = null;
    },
    drawpie() {
      let myChart = echarts.init(document.getElementById("pieEchars"));
      option.pieoption && myChart.setOption(option.pieoption);
      // if (arr.length !== 0) {
      //   let myCharts = echarts.init(document.getElementById("pieEcharstwo"));
      //   option.pieoptiontwo && myCharts.setOption(option.pieoptiontwo);
      // }
    },
    async getlineData() {
      let pamars = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        videoID: this.$parent.videoid,
      };
      if (this.$parent.courseware == "courseware") {
        pamars["courseID"] = this.$parent.videoid;
      }
      let res;
      let req;
      let ref;
      if (this.$parent.courseware != "courseware") {
        res = await resourcereq.videoProgress(pamars);
        // req = await resourcereq.videoComplete(pamars);
        ref = await resourcereq.videoDepartment(pamars);
      } else {
        res = await resourcereq.courseProgress(pamars);
        // req = await resourcereq.courseComplete(pamars);
        ref = await resourcereq.courseDepartment(pamars);
      }
      let allProgress = [
        //全体进度占比
        {
          value: res.data.Data.completePeopleCount,
          name: `已看完${res.data.Data.completePeopleCount}人，占比${res.data.Data.completeRatio}%`,
        },
        {
          value: res.data.Data.noCompletePeopleCount,
          name: `未看完${res.data.Data.noCompletePeopleCount}人，占比${res.data.Data.noCompleteRatio}%`,
        },
        {
          value: res.data.Data.noWatchCount,
          name: `未观看${res.data.Data.noWatchCount}人，占比${res.data.Data.noWatchRatio}%`,
        },
      ];
      allProgress = allProgress.filter((item) => {
        return item.value != 0;
      });
      // let wachingProgress = [
      //   //进行中进度占比
      //   {
      //     value: req.data.Data.level1.levelCount,
      //     name: `25%以下：${req.data.Data.level1.levelCount}人，占比${req.data.Data.level1.levelCountRatio}%`,
      //   },
      //   {
      //     value: req.data.Data.level2.levelCount,
      //     name: `25%-50%：${req.data.Data.level2.levelCount}人，占比${req.data.Data.level2.levelCountRatio}%`,
      //   },
      //   {
      //     value: req.data.Data.level3.levelCount,
      //     name: `50%-75%：${req.data.Data.level3.levelCount}人，占比${req.data.Data.level3.levelCountRatio}%`,
      //   },
      //   {
      //     value: req.data.Data.level4.levelCount,
      //     name: `75%-100%：${req.data.Data.level4.levelCount}人，占比${req.data.Data.level4.levelCountRatio}%`,
      //   },
      // ];
      // wachingProgress = wachingProgress.filter((item) => {
      //   return item.value != 0;
      // });
      //科室已完成，未开始，进行中
      let departMent0 = ref.data.Data.map((item) => item.DepartmentName); //科室数量
      let departMent1 = ref.data.Data.map((item) => item.completePeopleCount); //已看完
      let departMent2 = ref.data.Data.map((item) => item.noCompletePeopleCount); //进行中
      let departMent3 = ref.data.Data.map((item) => item.noWatchCount); //未开始
      option.lineoption.xAxis[0].data = departMent0;
      option.lineoption.series[0].data = departMent1;
      option.lineoption.series[1].data = departMent2;
      option.lineoption.series[2].data = departMent3;
      // option.pieoptiontwo.series[0].data = wachingProgress;
      option.pieoption.series[0].data = allProgress;
      this.drawpie();
      this.drawLine();
    },
    timeToSeconds(timeString) {
      const [hours, minutes, seconds] = timeString.split(":").map(Number);

      // 将小时转换为秒，分钟转换为秒，并加上原始的秒数
      const totalSeconds = hours * 3600 + minutes * 60 + seconds;
      return totalSeconds;
    },
    async getPageData() {
      this.loading = true;
      let pamars = {
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        videoID: this.$parent.videoid,
        pageIndex: this.currentPage3 - 1,
        pageShow: this.pageSize,
        departmentName: this.getDataCondition.region, // 科室
        studentUserName: this.getDataCondition.user, // 考生姓名
        isComplete: this.formInline.isComplete, // 是否学完
      };
      let rew;
      0;
      if (this.$parent.courseware == "courseware") {
        pamars["courseID"] = this.$parent.videoid;
        rew = await resourcereq.courseDetailList(pamars);
      } else {
        rew = await resourcereq.videoDetailList(pamars);
      }
      setTimeout(() => {
        this.loading = false;
      }, 500);
      this.getData = rew.data.Data[0];
      this.getData.map((item) => {
        for (let ztiem in item) {
          if (item[ztiem] === "" || item[ztiem] === null) {
            item[ztiem] = "无数据";
          }
        }
        item.progress1 = item.progress > 100 ? 100 : item.progress + "%";
      });
      this.total = rew.data.Data[1][0].dataCount;
    },
  },
  activated() {
    if (this.$parent.courseware == "courseware") {
      this.formColumns = [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "Telephone",
          label: "手机号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室",
          //   width: "100px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "isComplete",
          label: "是否学完",
          //  width: "80px",
        },
        // {
        //   prop: "userCount",
        //   label: "点击次数",
        //   //  width: "80px",
        // },
      ];
    } else {
      // 视频
      this.formColumns = [
        {
          prop: "RealName",
          label: "考生姓名",
          // width: "90px",
        },
        {
          prop: "UserName",
          label: "考生账号",
          // width: "90px",
        },
        {
          prop: "Telephone",
          label: "手机号",
          // width: "90px",
        },
        {
          prop: "DepartmentName",
          label: "科室",
          //   width: "100px",
        },
        {
          prop: "PTitle",
          label: "职称",
          // width: "90px",
        },
        {
          prop: "isComplete",
          label: "是否学完",
          //  width: "80px",
        },
        {
          prop: "videoTime",
          label: "视频时长",
          //  width: "80px",
        },
        {
          prop: "watchTime",
          label: "有效学习时长",
          // width: "80px",
        },
        // {
        //   prop: "progress1",
        //   label: "学习进度",
        //   // width: "80px",
        // },
        // {
        //   prop: "userCount",
        //   label: "点击次数",
        //   //  width: "80px",
        // },
      ];
    }
    // console.log(this.formColumns, "this.formColumns");
    // this.$parent.newState = 0;
    this.getPageData();
    this.getlineData();
  },
};
</script>
<style lang="scss" scoped>
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    //  background-color: aqua;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.nav_title {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  height: 60px;
  background-color: #d8edff;
  line-height: 60px;
  margin-top: 20px;
  padding-left: 20px;
}
.flex1 {
  display: flex;
  > h2 {
    margin-left: 200px;
  }
}
.nav_content {
  margin-top: 20px;
  padding: 24px;
  height: 500px;
  background-color: #ffffff;
}
.lineEchars {
  width: 100%;
  height: 100%;
}
.nav_scend {
  width: 100%;
  display: flex;
  height: 300px;
}
.jiange {
  width: 1%;
}
.nav_left {
  width: 50.5%;
  height: 300px;
  background-color: rgb(255, 255, 255);
}
.nav_right {
  width: 49.5%;
  // background-color: goldenrod;
  background-color: rgb(255, 255, 255);
}
.pieEchars {
  width: 100%;
  height: 100%;
}
.pieEcharstwo {
  width: 100%;
  height: 100%;
}
.nav_threed {
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  min-height: 300px;
  background-color: #ffffff;
}
// 分页
.foot_box {
  position: relative;
  height: 88px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    //background-color: #333333;
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
.openDatil {
  cursor: pointer;
  text-decoration: underline;
  color: #409eff;
  font-size: 16px;
}
.exportExcel {
  margin-left: 900px;
}
::v-deep .el-table th.el-table__cell > .cell {
  text-align: center;
}
::v-deep .el-table td.el-table__cell div {
  text-align: center;
}
::v-deep .el-table th > .cell {
  text-align: center;
}
::v-deep .el-table .cell {
  text-align: center;
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  // justify-content: space-between;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 100px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    text-align: left;
    color: #333333;
  }
  ::v-deep .el-form-item:nth-child(1) {
    .el-form-item__label {
      margin-left: 0 !important;
    }
  }
  ::v-deep .el-form-item:nth-child(2) {
    .el-form-item__label {
      width: 60px !important;
    }
  }
}
</style>